<template>
  <v-container fluid grid-list-lg>
    <v-row>
      <v-col cols="4">
        <StudentCount />
      </v-col>
      <v-col cols="4">
        <v-card color="primary" dark hover outlined flat @click="$router.push({ path: '/parents/noInvoice' })">
          <v-card-text style="height: 128px">
            <v-layout class="white--text" align-center="align-center" justify-center="justify-center" column="column"
              fill-height="fill-height">
              <v-progress-circular v-if="isLoading" size="50" width="5" color="white" indeterminate="indeterminate">
              </v-progress-circular>
              <div class="text-h2">{{ Customer }}</div>
              <div class="text-center body-1">Invoice Not Created </div>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card color="primary" dark hover outlined flat @click="$router.push({ path: '/parents/noSubscription' })">
          <v-card-text style="height: 128px">
            <v-layout class="white--text" align-center="align-center" justify-center="justify-center" column="column"
              fill-height="fill-height">
              <v-progress-circular v-if="isLoading" size="50" width="5" color="white" indeterminate="indeterminate">
              </v-progress-circular>
              <div class="text-h2">{{ CustomerWithoutSub }}</div>
              <div class="text-center body-1">Parents Subscription Not Created </div>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card color="primary" dark hover outlined flat @click="$router.push({ path: '/parents/list', query: { ShowBalanceOnly: true } })">
          <v-card-text style="height: 128px">
            <v-layout class="white--text" align-center="align-center" justify-center="justify-center" column="column"
              fill-height="fill-height">
              <v-progress-circular v-if="isLoading" size="50" width="5" color="white" indeterminate="indeterminate">
              </v-progress-circular>
              <div class="text-h3">{{ CustomerOutstandingBal | currency }}</div>
              <div class="text-center body-1">Parents Outstanding Balance</div>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card color="primary" dark hover outlined flat @click="$router.push({ path: '/donors/list', query: { ShowBalanceOnly: true } })">
          <v-card-text style="height: 128px">
            <v-layout class="white--text" align-center="align-center" justify-center="justify-center" column="column"
              fill-height="fill-height">
              <v-progress-circular v-if="isLoading" size="50" width="5" color="white" indeterminate="indeterminate">
              </v-progress-circular>
              <div class="text-h3">{{ DonorOutstandingBal | currency }}</div>
              <div class="text-center body-1">Donors Outstanding Balance </div>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-col>
     
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <v-card outlined class="rounded-lg">
          <v-card-title primary-title>
            {{ totalStudent }} Pending Application
          </v-card-title>
          <v-card-text>
            <!-- <v-subheader>Files</v-subheader> -->
            <v-list style="max-height: 350px; overflow: auto;">
              <template v-for="item in classesList">
                <div :key="item.name" v-if="item.totalStudentLeads !== 0">
                  <v-list-item @click="openStudentList(item)">
                    <v-list-item-content>
                      <v-list-item-title>{{ item.name }}</v-list-item-title>

                      <v-list-item-subtitle v-if="item.maleStudentLeads !== 0">{{ item.maleStudentLeads }} - Male
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="item.femaleStudentLeads !== 0">{{ item.femaleStudentLeads }} - Female
                      </v-list-item-subtitle>


                    </v-list-item-content>
                    <v-list-item-action>
                      <!-- <v-list-item-action-text>{{ item.totalStudentLeads }}</v-list-item-action-text> -->
                      <v-list-item-title class="font-weight-bold">{{ item.totalStudentLeads }}</v-list-item-title>



                    </v-list-item-action>
                  </v-list-item>
                </div>

              </template>

            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card outlined class="rounded-lg">
          <v-card-title primary-title>
            {{ unCommentLeads.length }} No Comments Application
          </v-card-title>
          <v-card-text>
            <!-- <v-subheader>Files</v-subheader> -->
            <v-list style="max-height: 350px; overflow: auto;">
              <v-list-item @click="profile(item)" v-for="(item, index) in unCommentLeads" :key="index">
                <v-list-item-content>
                  <v-list-item-title>{{ item.fatherName }}</v-list-item-title>
                  <v-list-item-subtitle><span>Created At: </span><span class="font-weight-bold black--text">{{
                      item.createdAt | moment("from", "now")
                  }}</span></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-title class="font-weight-bold text-capitalize">{{ item.LeadStudents[0].status }}
                  </v-list-item-title>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import StudentCount from "@/modules/Student/components/Count.vue";

import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import classService from '@/modules/Classes/service.js'
import leadService from '@/modules/Application/service.js'
import customerService from "@/modules/Customer/service.js";
import donorService from "@/modules/Donors/service.js";

import { mapGetters } from "vuex";

export default {
  name: "home",
  mixins: [RegisterStoreModule],
  data() {
    return {
      classesList: [],
      unCommentLeads: [],
      Customer: 0,
      CustomerOutstandingBal: 0,
      DonorOutstandingBal: 0,
      CustomerWithoutSub: 0,
      isLoading: false,
    }
  },
  components: {
    StudentCount,
    // PendingOrder,
    // SaleCount,
    // TodayPayment,
    // InvoiceCount,
    // SignUpCount,
    // InvoiceBySalesRep,
  },
  created() {

    document.title = "taleem - Home";
    this.getClassInfo()
    this.getLeadsWithOutComment()
    this.getNoInvoiceCount()
    this.getCustomerOutstandingBalance()
    this.getDonorOutstandingBalance()
    this.getNoSubCount()

  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    totalStudent() {
      let total = 0
      this.classesList.map(row => {
        total += row.totalStudentLeads
      })
      return total
    }
  },
  methods: {
    getNoInvoiceCount() {
      this.isLoading = true;
      let where = {
        start: this.$moment()
          .startOf("month")
          .toISOString(),
        end: this.$moment()
          .endOf("month")
          .toISOString(),
        limit: 1
      };
      // if (this.CustomerId) {
      //   where.CustomerId = this.CustomerId;
      // }
      // if (this.ClassId) {
      //   where.ClassId = this.ClassId;
      // }
      console.log("where", where);
      return customerService.getAllNoInvoice(where).then((response) => {
        console.log('response', response)
        this.isLoading = false;
        this.Customer = response.count;
        this.itemsPerPage = this.Customer.length

      });
    },
    getNoSubCount() {
      this.isLoading = true;
      return customerService.getAllNoSubscription().then((response) => {
        console.log('response CustomerWithoutSub', response)
        this.isLoading = false;
        this.CustomerWithoutSub = response.count;

      });
    },
    getCustomerOutstandingBalance(){
      customerService.getOutstandingBalance().then((response) => {
        this.CustomerOutstandingBal = response.data;

        this.isLoading = false;
      });
    },
    getDonorOutstandingBalance(){
      donorService.getOutstandingBalance().then((response) => {
        this.DonorOutstandingBal = response.data;

        this.isLoading = false;
      });
    },
    openStudentList(item) {
      console.log('item', item)
      this.$router.push({ path: '/applications/list', query: { ClassId: item.id, ClassName: item.name } })
    },
    profile(lead) {
      this.$router.push({ path: `/applications/${lead.id}/profile` });
    },
    getClassInfo() {
      classService.getClassInfo().then(result => {
        console.log('class info', result)
        this.classesList = result.data
      })
    },
    getLeadsWithOutComment() {
      leadService.leadsWithoutComment().then(result => {
        console.log('leadsWithoutComment', result)
        this.unCommentLeads = result.data
      })
    }
  }
};
</script>
